const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// const phonePattern = /^(\+{1}\d{2,3}\s?[(]{1}\d{1,3}[)]{1}\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}$/;
const phonePattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export function inputValidator(input, type) {
  switch (type) {
    case "numeric":
      return !isNaN(input);
    case "email":
      return emailPattern.test(String(input).toLowerCase());
    case "phone":
      return phonePattern.test(String(input).toLowerCase());
    default:
      return true;
  }
}

export function validateGln(input) {
  // Test string for correct length
  if (!input) {
    return false;
  }
  input = input.replace(/[\s\-]/g, "", );
  if(isNaN(input)){
    return false;
  }
  // let data = input.split("");
  if (input.length != 13) {
    return false;
  }
  // Test string for being numeric
  for (let i = 0; i < input.length; i++) {
    if (input.charCodeAt(i) < 0x30 || input.charCodeAt(i) > 0x39) return false;
  }
  let weight = 1;
  let sum = 0;
  for (let i = 0; i < input.length - 1; i++) {
    sum += parseInt(input.charAt(i), 10) * weight;
    weight = (weight + 2) % 4;
  }
  let remainder = (10 - (sum % 10)) % 10;
  return input.charAt(input.length - 1) == 0 + remainder;
}

export function validateOrgno(input, countryCode) {

  if (!input) {
    return false;
  }
  input = input.replace(/[\s\-]/g, "", );
  if(isNaN(input)){
    return false;
  }
  switch (countryCode) {
    // case "DNK":
    //   let bValid = input.length == 8;
    //   if (bValid) {
    //     bValid = true;
    //     let iRes = 0;
    //     let sMul = "27654321";
    //     for (let i = 0; i < input.length; i++) {
    //       iRes += new Number(input.substr(i, 1)) * parseInt(sMul.substr(i, 1));
    //     }
    //     bValid = iRes % 11 == 0;
    //   }
    //   return bValid;
    case "NOR":
      let gyldig = false;
      let kontrollsiffer = 0;
      let o = input.split("").map(i => {
        return parseInt(i, 10);
      });
      if (input.length == 9) {
        let sum =
          o[0] * 3 +
          o[1] * 2 +
          o[2] * 7 +
          o[3] * 6 +
          o[4] * 5 +
          o[5] * 4 +
          o[6] * 3 +
          o[7] * 2;
        let rest = sum % 11;
        let kontrollsiffer = rest === 0
        ? 0
        : 11 - rest;

        return rest != 1 && kontrollsiffer == o[8];
      } else {
        return false;
      }
    case "SWE":
    default:
      // Check valid length & form
      let numdigits = input.length
      if (input.indexOf("-") === -1) {
        if (input.length === 10) {
          input = input.slice(0, 6) + "-" + input.slice(6);
        } else {
          input = input.slice(0, 8) + "-" + input.slice(8);
        }
      }
      if (
        !input.match(
          /^(\d{2})(\d{2})(\d{2})\-(\d{4})|(\d{4})(\d{2})(\d{2})\-(\d{4})$/
        )
      ) {
        return false;
      }
      // Clean input
      input = input.replace("-", "");
      if (input.length === 12) {
        input = input.substring(2);
      }
      let sum = 0;
      // Check luhn algorithm
      for (let i = 0; i < input.length; i = i + 1) {
        let digit = parseInt(input.charAt(i), 10);
        if (i % 2 === input.length % 2) {
          digit *= 2;
        }
        if (digit > 9) {
          digit -= 9;
        }
        sum += digit;
      }
      return sum % 10 === 0;
  }
}
